import { render, staticRenderFns } from "./HSYS.vue?vue&type=template&id=673adcc6&scoped=true&"
import script from "./HSYS.vue?vue&type=script&lang=js&"
export * from "./HSYS.vue?vue&type=script&lang=js&"
import style0 from "./HSYS.vue?vue&type=style&index=0&id=673adcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673adcc6",
  null
  
)

export default component.exports